<template>
  <div class="border-situational-lightgrey overflow-hidden rounded-xl border">
    <div
      class="bg-situational-lightgrey text-text-neutral-secondary px-2 py-1 text-lg font-bold"
    >
      <slot name="title" />
    </div>
    <div class="p-2">
      <slot />
    </div>
  </div>
</template>
